  (function() {
    'use strict';

    var CMP_CFG = window.CM_POPUP_CFG || {};
    var POPUP_ID = CMP_CFG.id;
    var MIN_TIME_DEFAULT = 18;
    var MIN_TIME_RETURN = 18;
    var AUTO_OPEN_MS = 18000;
    var SCROLL_UP_THRESHOLD = 400;
    var MIN_SCROLL_DEPTH = 600;
    var INACTIVITY_MS = 45000;

    var storageOK = true;
    try { sessionStorage.setItem('_t', '1'); sessionStorage.removeItem('_t'); }
    catch(e) { storageOK = false; }

    function wasDismissed() {
      if (!storageOK) return false;
      return !!sessionStorage.getItem('casemira_popup_session');
    }
    function markDismissed() {
      if (!storageOK) return;
      sessionStorage.setItem('casemira_popup_session', '1');
    }
    function hasSubscribed() {
      if (!storageOK) return false;
      return !!localStorage.getItem('casemira_popup_subscribed');
    }
    function markSubscribed() {
      if (!storageOK) return;
      localStorage.setItem('casemira_popup_subscribed', '1');
    }

    /* ── CASEMIRA 04/09 · LA TRACE DE SOUMISSION, SUR DEUX SUPPORTS ────────
       Elle prouve que le formulaire a bien ete soumis DANS CET ONGLET : c'est
       elle, et elle seule, qui autorise l'ecran de succes au retour de
       Shopify sur `?customer_posted=true`. Sans elle, n'importe quelle
       adresse copiee-collee ferait apparaitre le code : la barriere reste.

       POURQUOI DEUX SUPPORTS. `sessionStorage` est le support naturel, mais il
       n'existe pas partout : en navigation privee et sous certains reglages de
       Safari, la moindre ecriture leve, et `storageOK` tombe a faux des le
       demarrage du fichier. La barriere refusait alors l'ecran de succes a un
       visiteur parfaitement legitime, qui voyait le message par defaut du
       theme. Un cookie de PREMIERE PARTIE, pose par notre propre gestionnaire
       de soumission et lu au retour, couvre ce cas sans rien affaiblir : il
       n'est pas plus facile a forger qu'une cle de session, il est de meme
       origine, il vit dix minutes et il est efface des sa lecture. */
    var TRACE = 'cmp_pending';

    function poseLaTrace() {
      try { sessionStorage.setItem(TRACE, '1'); } catch (e) {}
      try { document.cookie = TRACE + '=1; path=/; max-age=600; SameSite=Lax'; } catch (e) {}
    }

    function litLaTrace() {
      try { if (sessionStorage.getItem(TRACE)) return true; } catch (e) {}
      try { if (document.cookie.indexOf(TRACE + '=1') > -1) return true; } catch (e) {}
      return false;
    }

    function effaceLaTrace() {
      try { sessionStorage.removeItem(TRACE); } catch (e) {}
      try { document.cookie = TRACE + '=; path=/; max-age=0; SameSite=Lax'; } catch (e) {}
    }

    var popup, hasOpened = false, entryTime = Date.now();
    var maxY = 0, lastY = 0, upDist = 0;
    var idleTimer, wasHidden = false, autoTimer;
    var savedScrollY = 0;

    /* ── CORRECTIF D13 · LE VERROU DE DEFILEMENT ─────────────────────────────
       Le verrou etait un `position: fixed` sur `body` avec `top: -Npx`. Il
       fige la page derriere la pop-in, ecrase `document.scrollHeight` a la
       hauteur du viewport et perd la position de lecture ; sur mobile 390 la
       page n'existait plus tant que la pop-in etait la.

       On applique la regle du tiroir panier C4 (`assets/casemira-cart.js`
       ligne ~202) : `overflow` sur la RACINE, jamais `position: fixed` sur
       `body`. La classe `modal-show` etait DEJA posee sur `documentElement`
       par ce script, et `assets/theme.css` porte deja la regle
       `.modal-show { overflow: hidden; padding-right: var(--scrollbar-width) }`.
       Il suffisait donc de retirer les ecritures sur `body` et de definir
       `--scrollbar-width`, que rien dans le theme ne definissait : la
       compensation de barre etait inoperante et la page sautait de quelques
       pixels a l'ouverture sur les machines qui affichent une barre.

       La largeur est mesuree au demarrage et au redimensionnement, JAMAIS sur
       le chemin d'ouverture (meme raison que dans le panier C4 : une lecture
       de `clientWidth` juste apres avoir pose la classe force un recalcul de
       mise en page du document entier, au pire moment).

       LES DECLENCHEURS NE SONT PAS TOUCHES : la minuterie de 18 s et celle
       d'inactivite de 45 s restent telles quelles, comme les seuils. */
    var sbwPose = false;

    function mesureLaBarre() {
      if (document.documentElement.classList.contains('modal-show')) return;
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty('--scrollbar-width', sbw + 'px');
      sbwPose = true;
    }
    window.addEventListener('resize', mesureLaBarre);

    function verrouille() {
      savedScrollY = window.pageYOffset || document.documentElement.scrollTop;
      if (!sbwPose) mesureLaBarre();
      document.documentElement.classList.add('modal-show');
    }

    function deverrouille() {
      document.documentElement.classList.remove('modal-show');
      /* La position de lecture n'a pas bouge, aucun `position: fixed` ne l'a
         effacee. On la restitue tout de meme si un tiers l'a deplacee. */
      if (Math.abs((window.pageYOffset || 0) - savedScrollY) > 1) window.scrollTo(0, savedScrollY);
    }

    function reduitLeMouvement() {
      try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
      catch (e) { return false; }
    }

    /* ── CASEMIRA 04/09 · LA POP-IN NE S'OUVRE PAS PAR-DESSUS UN CALQUE ───
       Raph, 03/09 a 22 h 56, telephone, site publie : la pop-in « -10 % sur
       votre 1ere commande » s'ouvre PAR-DESSUS le tiroir panier ouvert. Le
       declencheur temporise tombe pendant que le tiroir vit, et rien ne
       regardait si une surcouche plein ecran etait deja la.

       LA REGLE, ET ELLE TIENT EN UNE LIGNE : tant que la racine porte
       `cm-over`, la pop-in ne s'ouvre pas. `cm-over` est le nom generique de
       « une surcouche plein ecran est ouverte » (`casemira-tokens.css`, la
       politique des calques ecrite une fois a la vague 1 du chantier 4). Le
       tiroir panier la pose, mais aussi le lecteur video, la feuille de
       filtres et la mini-fiche : un seul test les couvre toutes, et il
       couvrira la prochaine sans une ligne de plus.

       CE N'EST PAS UN ABANDON, C'EST UNE FILE D'ATTENTE. Si le declencheur
       tombe pendant qu'un calque vit, la pop-in prend son tour : elle attend
       `cmk:close` (l'evenement du tiroir) ou le retrait de la classe (le filet
       pour un calque qui n'emet rien), puis s'ouvre apres un court delai, UNE
       fois. Le delai n'est pas cosmetique : la feuille du tiroir met 400 ms a
       sortir du cadre, et ouvrir dans son sillage donnerait deux mouvements
       pour un.

       RIEN D'AUTRE NE BOUGE. Les declencheurs (18 s, inactivite 45 s, sortie
       par le haut, retour d'onglet, defilement), les seuils, la frequence par
       session, les textes et les visuels sont ceux d'avant : le declencheur se
       decide dans le chantier newsletter. */
    var DELAI_APRES_CALQUE = 1200;
    var enFile = false;

    function unCalqueEstOuvert() {
      return document.documentElement.classList.contains('cm-over');
    }

    function prendSonTour() {
      if (enFile) return;
      enFile = true;
      var observateur = null;
      function relance() {
        /* Un autre calque a pu prendre la suite : on reste en file. */
        if (unCalqueEstOuvert()) return;
        document.removeEventListener('cmk:close', relance);
        if (observateur) observateur.disconnect();
        setTimeout(function() {
          enFile = false;
          open(0);
        }, DELAI_APRES_CALQUE);
      }
      document.addEventListener('cmk:close', relance);
      if (typeof MutationObserver === 'function') {
        observateur = new MutationObserver(relance);
        observateur.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      }
    }

    /* ── CASEMIRA 04/09 · LE CODE PROMO APRES INSCRIPTION, QUEL QUE SOIT LE
       CHEMIN D'OUVERTURE ────────────────────────────────────────────────────
       Raph, 04/09 a 14 h 07, telephone, site publie : il s'inscrit depuis le
       bouton « Je m'inscris » de la barre haute et l'ecran de succes affiche
       le message vert par defaut du theme, PAS le code promo copiable.

       LA CAUSE, ET ELLE TIENT EN UNE LIGNE : l'ecouteur de soumission du
       formulaire etait attache DANS `open()`. Or `open()` n'est qu'UN des
       chemins d'ouverture. `assets/casemira-topbar.js` ouvre la pop-in en
       posant lui-meme les attributs `open` et `active` sur l'element, sans
       jamais passer par `open()` : l'ecouteur n'existait pas, la cle
       `cmp_pending` n'etait jamais posee, et au retour de Shopify sur
       `?customer_posted=true` la barriere de `handlePostSubscription()`
       rendait la main. Le theme affichait alors son propre message.

       LA CORRECTION : le formulaire est arme UNE fois a l'initialisation, et
       plus a l'ouverture. Il vit dans le document des le rendu de la section,
       pop-in ouverte ou non ; tous les chemins d'ouverture (minuterie de 18 s,
       inactivite, sortie par le haut, barre haute, et le prochain qu'on
       ajoutera) aboutissent donc au meme ecran de succes.

       L'ARMEMENT PASSE AVANT LE RETOUR ANTICIPE DE `init()`. Un visiteur qui a
       ferme la pop-in (`casemira_popup_session`) puis clique « Je m'inscris »
       dans la barre haute doit avoir son code : ce retour ne gouverne que les
       OUVERTURES AUTOMATIQUES, jamais l'armement du formulaire.

       LA BARRE HAUTE N'EST PAS TOUCHEE. Lui faire appeler `open()` aurait
       partage le verrou et la garde `cm-over`, mais aussi ses refus : `open()`
       rend la main si la pop-in a deja ete fermee dans la session ou si le
       visiteur est deja inscrit, et un clic explicite sur « Je m'inscris »
       n'ouvrirait alors plus rien. Un clic demande doit toujours ouvrir.

       RIEN D'AUTRE NE BOUGE : ni les declencheurs, ni les seuils, ni la garde
       `cm-over` du lot N, ni un seul texte. Seules les trois traces de mise au
       point (`console.log('DEBUG...')`) partent avec le bloc deplace. */
    var formulaireArme = false;

    function armeLeFormulaire(racine) {
      if (formulaireArme || !racine) return;
      var form = racine.querySelector('form');
      if (form) {
        formulaireArme = true;
        form.addEventListener('submit', function(e) {
          /* Langues dont la pop-up passe par le relais : liste unique, tenue dans
             assets/casemira-newsletter-routing.js (`window.cmNewsletterRelais`).
             Repli identique a l'ancienne liste si ce script n'est pas charge. */
          var relaisPopup = (window.cmNewsletterRelais && window.cmNewsletterRelais.popup) || ['de', 'nl', 'en', 'it', 'es', 'pt', 'cs', 'sk', 'da', 'hu', 'hr', 'ro', 'sv', 'fi', 'el', 'bg', 'sl', 'lv', 'et', 'lt'];
          if (relaisPopup.indexOf(document.documentElement.lang.toLowerCase().split('-')[0]) !== -1) return;
          e.preventDefault();
          markSubscribed();
          poseLaTrace();

          var emailInput = form.querySelector('input[name="contact[email]"]');
          var email = emailInput ? emailInput.value.trim() : '';

          var submitted = false;
          function submitForm() {
            if (submitted) return;
            submitted = true;
            form.submit();
          }

          if (email) {
            var urlParams = new URLSearchParams(window.location.search);
            var lastCollection = '';
            try {
              var pathMatch = document.referrer.match(/\/collections\/([^\/\?]+)/);
              lastCollection = pathMatch ? pathMatch[1] : '';
            } catch(err) {}

            var properties = {
              acquisition_source: urlParams.get('utm_source') || 'direct',
              acquisition_medium: urlParams.get('utm_medium') || '',
              acquisition_campaign: urlParams.get('utm_campaign') || '',
              popup_signup_at: new Date().toISOString(),
              last_collection_viewed: lastCollection,
              signup_page: window.location.pathname
            };

            try {
              if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
                window.klaviyo.identify({ email: email });
              } else if (window._learnq) {
                window._learnq.push(['identify', { '$email': email }]);
              }
            } catch(err) {
              console.warn('Klaviyo identify failed:', err);
            }

            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=TM6pHJ', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'revision': '2024-10-15'
  },
  body: JSON.stringify({
    data: {
      type: 'subscription',
      attributes: {
        custom_source: 'Pop-up Newsletter -10%',
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: email,
              properties: properties
            }
          }
        }
      },
      relationships: {
        list: {
          data: { type: 'list', id: 'SiJZYk' }
        }
      }
    }
  })
})

            .then(function(response) {
              console.log('Klaviyo subscribe status:', response.status);
              return response.text();
            })
            .then(function(body) {
              console.log('🔍 Klaviyo response body:', body);
              submitForm();
            })
            .catch(function(err) {
              console.warn('Klaviyo subscribe failed:', err);
              submitForm();
            });

            setTimeout(submitForm, 5000);
          } else {
            submitForm();
          }
        });
      }
    }

    function open(minTime) {
      if (minTime == null) minTime = MIN_TIME_DEFAULT;
      if (hasOpened || !popup) return;
      if (wasDismissed() || hasSubscribed()) return;
      if ((Date.now() - entryTime) / 1000 < minTime) return;
      /* CASEMIRA 04/09 : un calque plein ecran vit, la pop-in prend son tour. */
      if (unCalqueEstOuvert()) { prendSonTour(); return; }
      hasOpened = true;
      off();

      verrouille();

      popup.removeAttribute('hidden');
      popup.setAttribute('open', '');
      if (reduitLeMouvement()) {
        /* Pas de montee : l'etat final est pose tout de suite. La feuille
           `casemira-popup.css` coupe la transition sous la meme requete. */
        popup.setAttribute('active', '');
      } else {
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            popup.setAttribute('active', '');
          });
        });
      }

      var overlay = popup.querySelector('.fixed-overlay');

      function closePopup() {
        markDismissed();
        popup.removeAttribute('active');
        deverrouille();

        if (overlay) overlay.style.pointerEvents = 'none';
        setTimeout(function() {
          popup.setAttribute('hidden', '');
          popup.removeAttribute('open');
          if (overlay) overlay.style.pointerEvents = '';
        }, reduitLeMouvement() ? 0 : 400);
      }

      if (overlay) overlay.addEventListener('click', closePopup);
      var closeBtn = popup.querySelector('.drawer__close-btn');
      if (closeBtn) closeBtn.addEventListener('click', closePopup);
      document.addEventListener('keydown', function escH(e) {
        if (e.key === 'Escape') { closePopup(); document.removeEventListener('keydown', escH); }
      });

      /* Le formulaire est arme a l'initialisation, pas ici : voir
         `armeLeFormulaire()` ci-dessus. */
    }


    function onMouse(e) {
      if (e.clientY <= 5 && !e.relatedTarget) open();
    }
    function onVis() {
      if (document.visibilityState === 'hidden') { wasHidden = true; }
      else if (wasHidden) { wasHidden = false; setTimeout(function() { open(MIN_TIME_RETURN); }, 800); }
    }
    function onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      if (y > maxY) maxY = y;
      if (y < lastY) upDist += lastY - y; else upDist = 0;
      if (maxY >= MIN_SCROLL_DEPTH && upDist >= SCROLL_UP_THRESHOLD) open();
      lastY = y;
      resetIdle();
    }
    function resetIdle() {
      if (idleTimer) clearTimeout(idleTimer);
      idleTimer = setTimeout(open, INACTIVITY_MS);
    }
    function onAct() { resetIdle(); }

    function on() {
      var m = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      if (m) {
        document.addEventListener('visibilitychange', onVis);
        window.addEventListener('scroll', onScroll, { passive: true });
        document.addEventListener('touchstart', onAct, { passive: true });
        document.addEventListener('touchmove', onAct, { passive: true });
      } else {
        document.addEventListener('mouseout', onMouse);
        document.addEventListener('mousemove', onAct, { passive: true });
        document.addEventListener('keydown', onAct, { passive: true });
      }
      document.addEventListener('click', onAct, { passive: true });
      resetIdle();
      autoTimer = setTimeout(function() { open(0); }, AUTO_OPEN_MS);
    }

    function off() {
      if (idleTimer) clearTimeout(idleTimer);
      if (autoTimer) clearTimeout(autoTimer);
      document.removeEventListener('mouseout', onMouse);
      document.removeEventListener('visibilitychange', onVis);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('touchstart', onAct);
      document.removeEventListener('touchmove', onAct);
      document.removeEventListener('mousemove', onAct);
      document.removeEventListener('keydown', onAct);
      document.removeEventListener('click', onAct);
    }

    function init() {
      /* CASEMIRA 04/09 : L'ARMEMENT DU FORMULAIRE PASSE AVANT TOUT LE RESTE.
         `wasDismissed() || hasSubscribed()` ne gouverne que les OUVERTURES
         AUTOMATIQUES ; le formulaire, lui, doit repondre meme quand la pop-in
         ne s'ouvrira plus d'elle-meme, puisque la barre haute peut encore
         l'ouvrir sur un clic. */
      popup = document.getElementById(POPUP_ID);
      if (popup) {
        armeLeFormulaire(popup);
        if (!wasDismissed() && !hasSubscribed()) on();
        return;
      }
      setTimeout(function() {
        popup = document.getElementById(POPUP_ID);
        if (!popup) return;
        armeLeFormulaire(popup);
        if (!wasDismissed() && !hasSubscribed()) on();
      }, 500);
    }

    if (document.readyState === 'loading')
      document.addEventListener('DOMContentLoaded', init);
    else init();

    /* ============================================================
       POST-INSCRIPTION - tue le modal du thème, affiche le code promo
       ============================================================ */
    function handlePostSubscription() {
      if (window.location.search.indexOf('customer_posted') === -1) return;

      // Barrière : l'écran succès n'apparaît que si le formulaire a été soumis dans cet onglet
      // (une URL ?customer_posted=true forgée ou copiée n'a pas cette trace).
      // CASEMIRA 04/09 : la trace se lit sur ses deux supports, `sessionStorage`
      // ET le cookie de première partie, pour que les navigateurs qui refusent
      // le stockage de session ne privent pas un vrai inscrit de son code.
      if (!litLaTrace()) return;
      effaceLaTrace();

      /* CASEMIRA 04/09 : le message vert par defaut du theme
         (`newsletter.success` de `locales/fr.json`, rendu par
         `snippets/newsletter-form.liquid` dans `NewsletterAlertModal-*` sous
         l'identifiant `Newsletter-success--*`) ne doit JAMAIS coexister avec
         notre ecran de succes. On retire la modale ET le paragraphe, parce que
         le second existe meme quand la premiere n'a pas ete ouverte. */
      function killThemeModals() {
        document.querySelectorAll('.modal--newsletter-alert, [id*="NewsletterAlertModal"], [id^="Newsletter-success--"]').forEach(function(m) {
          m.removeAttribute('open');
          m.removeAttribute('active');
          m.setAttribute('hidden', '');
          m.style.display = 'none';
        });
      }
      killThemeModals();
      setTimeout(killThemeModals, 200);
      setTimeout(killThemeModals, 600);
      setTimeout(killThemeModals, 1200);

      var p = document.getElementById(POPUP_ID);
      if (!p) return;

      var grid = p.querySelector('.cmp-grid');
      var success = p.querySelector('.cmp-success');
      if (grid) grid.style.cssText = 'display:none !important';
      if (success) success.classList.add('is-visible');

      p.removeAttribute('hidden');
      p.setAttribute('open', '');
      if (reduitLeMouvement()) {
        p.setAttribute('active', '');
      } else {
        requestAnimationFrame(function() {
          requestAnimationFrame(function() { p.setAttribute('active', ''); });
        });
      }

      verrouille();

      function closeSuccess() {
        p.removeAttribute('active');
        deverrouille();
        setTimeout(function() {
          p.setAttribute('hidden', '');
          p.removeAttribute('open');
        }, reduitLeMouvement() ? 0 : 400);
      }
      var overlay = p.querySelector('.fixed-overlay');
      if (overlay) overlay.addEventListener('click', closeSuccess);
      var closeBtn = p.querySelector('.drawer__close-btn');
      if (closeBtn) closeBtn.addEventListener('click', closeSuccess);
      document.addEventListener('keydown', function escH(e) {
        if (e.key === 'Escape') { closeSuccess(); document.removeEventListener('keydown', escH); }
      });
      var ctaLink = p.querySelector('.cmp-success-cta');
      if (ctaLink) {
        ctaLink.addEventListener('click', function() { closeSuccess(); });
      }

      var copyBtn = document.getElementById('cmpCodeCopy-' + CMP_CFG.sid);
      var codeVal = document.getElementById('cmpCodeValue-' + CMP_CFG.sid);
      if (codeVal && codeVal.dataset.c && !codeVal.textContent.trim()) {
        try { codeVal.textContent = atob(codeVal.dataset.c); }
        catch (err) { codeVal.textContent = ''; }
      }
      if (copyBtn && codeVal) {
        /* i18n : les deux etats du bouton sont poses par `popup.liquid`
           (CONVENTION section 4). `copier` est la MEME cle que celle peinte par
           le Liquid : une cle, deux consommateurs. Repli code sur chacune. */
        var lblCopier = copyBtn.getAttribute('data-cmp-label-copier') || 'Copier';
        var lblCopie = copyBtn.getAttribute('data-cmp-label-copie') || 'Copié ✓';
        copyBtn.addEventListener('click', function() {
          navigator.clipboard.writeText(codeVal.textContent.trim()).then(function() {
            copyBtn.textContent = lblCopie;
            setTimeout(function() { copyBtn.textContent = lblCopier; }, 2500);
          }).catch(function() {
            var range = document.createRange();
            range.selectNodeContents(codeVal);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
            document.execCommand('copy');
            sel.removeAllRanges();
            copyBtn.textContent = lblCopie;
            setTimeout(function() { copyBtn.textContent = lblCopier; }, 2500);
          });
        });
      }

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname);
      }
    }

    if (document.readyState === 'loading')
      document.addEventListener('DOMContentLoaded', handlePostSubscription);
    else handlePostSubscription();
  })();
